export default {
      id: "grid-usage",
      viewBox: "0 0 512 446",
      url: __webpack_public_path__ + "img/svg-sprite.svg#grid",
      toString: function () {
        return this.url;
      }
    }